export enum PermissionAction {
  CREATE = 'create',
  READ = 'read',
  UPDATE = 'update',
  DELETE = 'delete',
  MANAGE = 'manage',
  VIEW = 'view',
  FILTER = 'filter',
  SEARCH = 'search',
  DECLINE = 'decline',
  APPROVE = 'approve',
}
export enum Role {
  Admin = 'Admin',
  Accountant = 'Accountant',
  Staff = 'Staff',
}

export enum PermissionObject {
  ALL = 'all',
  STAFF = 'Staff',
  PAYSLIP = 'Payslip',
  PAY_PERIOD = 'PayPeriod',
  CONTRACT = 'Contract',
  SALARY_GRID = 'SalaryGrid',
  CNPS_DECLARATION = 'CnpsDeclaration',
  CNPS_DECLARATION_DETAIL = 'CnpsDeclarationDetail',
  ALLOWANCE = 'Allowance',
  COMPANY = 'Company',
  STAFF_LEAVE_REQUEST = 'StaffLeaveRequest',
  USER = 'User',
  PAYSLIP_ALLOWANCE = 'PayslipAllowance',
  CONTRACT_ALLOWANCE = 'ContractAllowance',
  PLAN = 'Plan',
  CUSTOMER = 'Customer',
  PAYROLL_ELEMENT = 'PayrollElement',
  TRANSACTION = 'Transaction',
  STAFF_SNAPSHOT = 'StaffSnapshot',
  STATEMENT = 'Statement',
  TEAM = 'Team',
  LOAN_REQUEST = 'LoanRequest',
  HOME = 'Home',
  MIGRATION = 'Migration',
  ACCOUNT = 'Account',
  ACCOUNTING_BOOK = 'AccountingBook',
  BANK_ACCOUNT = 'BankAccount',
  CYCLE_COUNT = 'CycleCount',
  STAFF_INVOICE = 'StaffInvoice',
  BILLING_ITEM = 'BillingItem',
  DECLARATION_PERIOD = 'DeclarationPeriod',
  TAX_DECLARATION = 'TaxDeclaration',
  CREDENTIAL = 'Credential',
  PAYROLL_SESSION = 'PayrollSession',
  ADMIN = 'Admin',
}

export const DEFAULT_ROLE_ID = 1;
export const STAFF_ROLE_ID = 3;
